import PropTypes from "prop-types";
import React from "react";
import Button from "../../UI/button";

const HeroSliderOneSingle = ({ data, styles, sliderClassName }) => {
  return (
    <div
      className={`${styles.slide} ${styles.sliderFixedHeight} ${
        styles.graBg1
      } ${sliderClassName ? sliderClassName : ""} d-flex align-items-center`}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-sm-12 col-xl-12">
            <div className={`${styles.content}`}>
              <h1>{data.title}</h1>
              <p>{data.text}</p>
              <p className={`${styles.disclose}`}>*We are an independent retailer. Services are provided and billed by the carriers. Availability and speeds vary by location.</p>
              {/* <a href={data.url} className={`${styles.btn}`}>Check Availability</a> */}
              <a href="tel:+1 (877) 514-5141" className={`${styles.btn}`}>Call Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

HeroSliderOneSingle.propTypes = {
  data: PropTypes.object,
  styles: PropTypes.object
};

export default HeroSliderOneSingle;
